export type Image = {
  alt: string
  id: number
  name: string
  sizes: ImageSizes
  src: string
  srcset: string
}

export enum ImageSize {
  Full = 'full',
  Large = 'large',
  Medium = 'medium',
  Thumbnail = 'thumbnail',
}

export type ImageSizes = {
  [ImageSize.Full]: string
  [ImageSize.Large]: string
  [ImageSize.Medium]: string
  [ImageSize.Thumbnail]: string
}
